import { render, staticRenderFns } from "./SetForm.vue?vue&type=template&id=730d508f&scoped=true&"
import script from "./SetForm.vue?vue&type=script&lang=js&"
export * from "./SetForm.vue?vue&type=script&lang=js&"
import style0 from "./SetForm.vue?vue&type=style&index=0&id=730d508f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "730d508f",
  null
  
)

export default component.exports